import { Security } from "@mui/icons-material";
import { getUser } from "auth/authenticate";
import { PatientSidebar } from "components/common/patientSidebar/PatientSidebar";
import PaymentComplete from "components/common/RegisterForm/ConsultationRegisterStepper/PaymentComplete";
import useUser from "context/user/useUser";
import {
  OtpScreen,
  ForgetPasswordPage,
  ResetPassword,
  Login,
  Appointments,
  AppointmentDetailsPage,
} from "pages";
import AppointmentConsultation from "pages/appointment/AppointmentConsultation";
import PaymentSuccess from "pages/appointmentByAdmin/ExtAppointmentSetupComplete/PaymentSuccess";
import { JoinVideoConsultation } from "pages/appointmentByAdmin/JoinVideoConsultation";
import { JoinVideoConsultation2 } from "pages/appointment/JoinVideoConsultationInternal";
import ExternalAppointmentSetup from "pages/appointmentByAdmin/VerificationExtAptLink/AptExternalSetup";
import Registration from "pages/authentication/Registration/Registration";
import AddAppointment2 from "pages/doctorDetails/addAppointment2/AddAppointment2";
import AddAppointment3 from "pages/doctorDetails/addAppointment3/AddAppointment3";
import AddAppointments from "pages/doctorDetails/addAppointments/AddAppointments";
import DoctorDetails from "pages/doctorDetails/DoctorDetails";
import Thankyou from "pages/doctorDetails/thankyouPage/Thankyou";
import ExternalMedicalReport from "pages/externalPatientServices/extMedicalReports";
import { Favourites } from "pages/favourites/Favourites";
import LoadingSpinner from "components/loading-spinner/LoadingSpinner";

import OrderDetails from "pages/orders/orderDetails/OrderDetails";
import { Orders } from "pages/orders/Orders";
import PatientDashboard from "pages/patientDashboard/PatientDashboard";
import PatientProfile from "pages/patientProfile/PatientProfile";
import PatientSettings from "pages/patientSettings/PatientSettings";
import { EarningHistory } from "pages/paymentHistory/earningHistory/EarningHistory";
import { MakePayment } from "pages/paymentHistory/makePayment";
import { PaymentHistory } from "pages/paymentHistory/paymentHistory";
import { AddMoreInfo } from "pages/pharmacies/addMoreInfo/AddMoreInfo";
import { Pharmacies } from "pages/pharmacies/Pharmacies";
import PharmacyInfo from "pages/pharmacies/pharmacyInfo/PharmacyInfo";
import Privacy from "pages/settings/privacyControl/Privacy";
import React, { forwardRef, Suspense, useState, lazy } from "react";
import { Outlet, Route, Routes, Navigate } from "react-router-dom";
import ContactUs from "pages/contact/ContactUs";
import NotFound from "pages/NotFound";
import Blog from "pages/blog/Blog";
import BookingComplete from "pages/bookingModel/BookingComplete";
import PatientWaitingRoom from "pages/appointment/PatientWaitingRoom";
import PatientConsultationRoom from "pages/appointment/PatientConsultationRoom";

export const Home = lazy(() => import("pages/home/Home.jsx"));
export const AboutPage = lazy(() => import("pages/about/About.jsx"));
export const Doctors = lazy(() => import("pages/doctors/Doctors.jsx"));
export const Join = lazy(() => import("pages/Join.jsx"));
export const TermsConditions = lazy(() => import("pages/TermsConditions.jsx"));
export const PrivacyPolicy = lazy(() => import("pages/PrivacyPolicy.jsx"));
export const FAQs = lazy(() => import("pages/FAQs.jsx"));

// Route guard component
const ProtectedRoute = ({ children, allowedRoles, userRole }) => {
  // console.log("Current userRole:", userRole);
  // console.log("Allowed roles:", allowedRoles);
  // console.log("Your user data:", getUser());
  return allowedRoles.includes(userRole) ? children : <Navigate to="/" />;
};

const DeedRoutes = forwardRef((props, ref) => {
  const { userRole } = useUser();
  const [notification, setNotification] = useState({ title: "", body: "" });

  const SidebarLayout = ({ notification }) => (
    <>
      {
        userRole === "PATIENT"
        // && <PatientSidebar />
      }
      <div className="appMainArea">
        <Outlet />
      </div>
    </>
  );

  return (
    <>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/otpScreen" element={<OtpScreen />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/forgetpassword" element={<ForgetPasswordPage />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/login" element={<Login />} />
          <Route path="/about" element={<AboutPage />} />

          {/* Blog Routes - All public routes */}
          <Route path="/news" element={<Blog />} />
          <Route path="/news/:postSlug" element={<Blog />} />
          <Route path="/news/category/:categorySlug" element={<Blog />} />
          <Route path="/news/search" element={<Blog />} />

          <Route path="/contact" element={<ContactUs />} />
          {/* <Route path="/services" element={<ServicesPage />} /> */}
          {/* <Route path="/" element={<Home />} /> */}
          {/* after landing page add */}
          <Route path="/" element={<Home />} />
          {/* <Route path="/ext-medical-report/:reportLink" element={<ExternalMedicalReport />} /> */}
          <Route
            path="/ext-medical-report"
            element={<ExternalMedicalReport />}
          />

          {/* Protected routes */}
          <Route
            element={<SidebarLayout notification={notification} ref={ref} />}
          >
            <Route path="/" element={<PatientDashboard />} />

            {/* Patient-specific routes */}

            {/* external appointment link with payment for existing users */}
            <Route
              path="apt-external/payment-link/:appointmentId"
              element={
                <ProtectedRoute allowedRoles={["PATIENT"]} userRole={userRole}>
                  <ExternalAppointmentSetup />
                </ProtectedRoute>
              }
            />

            {/* external guest appointment link with payment for anonymous users */}
            {/* <Route
          path="/guest-apt/thank-you/:appointmentId"
          element={
            <ProtectedRoute allowedRoles={["GUEST"]} userRole={userRole}>
              <PaymentComplete />
            </ProtectedRoute>
          }
        /> */}

            {/* <Route
              path="/payment-forapt/thank-you/:appointmentId"
              element={
                <ProtectedRoute allowedRoles={["PATIENT"]} userRole={userRole}>
                  <PaymentComplete />
                </ProtectedRoute>
              }
            /> */}

            {/* the latest working Thank you and appointment summary page after payment completion */}
            <Route
              path="/payment-forapt/thank-you/:appointmentId"
              element={
                <ProtectedRoute allowedRoles={["PATIENT"]} userRole={userRole}>
                  <BookingComplete />
                </ProtectedRoute>
              }
            />

            <Route
              path="/patient-dashboard"
              element={
                <ProtectedRoute allowedRoles={["PATIENT"]} userRole={userRole}>
                  <PatientDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/appointments"
              element={
                <ProtectedRoute allowedRoles={["PATIENT"]} userRole={userRole}>
                  <Appointments />
                </ProtectedRoute>
              }
            />
            <Route
              path="/appointment-consultation/:id"
              element={
                <ProtectedRoute
                  allowedRoles={["PATIENT", "GUARDIAN"]}
                  userRole={userRole}
                >
                  <AppointmentConsultation />
                </ProtectedRoute>
              }
            />

            <Route
              path="/appointment-consultation/:id/waiting"
              element={
                <ProtectedRoute
                  allowedRoles={["PATIENT", "GUARDIAN"]}
                  userRole={userRole}
                >
                  {" "}
                  <PatientWaitingRoom />
                </ProtectedRoute>
              }
            />

            <Route
              path="/appointment-consultation/:id/call"
              element={
                <ProtectedRoute
                  allowedRoles={["PATIENT", "GUARDIAN"]}
                  userRole={userRole}
                >
                  <PatientConsultationRoom />
                </ProtectedRoute>
              }
            />

            <Route
              path="/appointments/:action/:id"
              element={
                <ProtectedRoute allowedRoles={["PATIENT"]} userRole={userRole}>
                  <Appointments />
                </ProtectedRoute>
              }
            />
            <Route
              path="/patient-profile"
              element={
                <ProtectedRoute allowedRoles={["PATIENT"]} userRole={userRole}>
                  <PatientProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/patient-settings"
              element={
                <ProtectedRoute allowedRoles={["PATIENT"]} userRole={userRole}>
                  <PatientSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/patient-settings/payments"
              element={
                <ProtectedRoute allowedRoles={["PATIENT"]} userRole={userRole}>
                  <EarningHistory />
                  {/* <PaymentHistory/> */}
                </ProtectedRoute>
              }
            />
            <Route
              path="/patient-settings/privacy"
              element={
                <ProtectedRoute allowedRoles={["PATIENT"]} userRole={userRole}>
                  <Privacy />
                </ProtectedRoute>
              }
            />

            {/* Routes accessible by all users */}
            <Route
              path="/appointment-details/:id"
              element={<AppointmentDetailsPage />}
            />
            <Route path="/doctors" element={<Doctors />} />
            <Route path="/favourites" element={<Favourites />} />
            <Route path="/pharmacies/" element={<Pharmacies />} />
            <Route
              path="/pharmacies/pharmacy-info/:id"
              element={<PharmacyInfo />}
            />
            <Route
              path="/pharmacies/pharmacy-info/:id/add-more-info"
              element={<AddMoreInfo />}
            />
            <Route
              path="/doctors/:id"
              // element={<DoctorDetails />}
              element={<AddAppointments />}
              // element={<div>asdasdasd</div>}
            />
            <Route
              path="/doctors/doctor-details/:id/add-appointments"
              element={<AddAppointments />}
            />
            <Route path="/doctors/:id/:day" element={<AddAppointments />} />
            <Route
              path="/doctors/:id/fill-details"
              element={<AddAppointment2 />}
            />
            <Route
              path="/doctors/:id/:day/fill-details"
              element={<AddAppointment2 />}
            />
            <Route
              path="/doctors/:id/fill-details/make-payment"
              element={<AddAppointment3 />}
            />
            <Route
              path="/doctors/:id/:day/fill-details/make-payment"
              element={<AddAppointment3 />}
            />
            <Route
              path="/doctors/:id/fill-details/make-payment/thank-you/:id"
              element={<Thankyou />}
            />
            <Route path="/orders" element={<Orders />} />
            <Route
              path="/orders/order-details/:id"
              element={<OrderDetails />}
            />
            <Route path="/patient-settings/security" element={<Security />} />
            <Route path="/make-payment" element={<MakePayment />} />

            {/* <Route
              path="/appointment/join-video-consultation/:appointmentId"
              element={<JoinVideoConsultation2 />}
            /> */}

            {/* the working appointment consultation join page for latest booking model flow */}
            <Route
              path="/apt-external/join-consultation"
              element={<JoinVideoConsultation />}
            />
            <Route
              path="/apt-external/payment/join-consultation/:aptId"
              element={<PaymentSuccess />}
            />

            <Route path="/join" element={<Join />} />
            <Route path="/term-conditions" element={<TermsConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/faqs" element={<FAQs />} />

            {/* Redirect unknown routes */}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </>
  );
});

export default DeedRoutes;
